/**
 * Created by anthony on 11/23/14.
 */
var ismfast = angular.module('ismfast', ['ui.router', 'authService', 'ngCookies', 'applicationSidebar', 'bin',
    'ui.bootstrap','login', 'restService', 'schoolside', 'postService', 'purgeService', 'archive', 'modelService',
    'datePickerDirective', 'circularProgress', 'helpCardMessage', 'helpCardAwardData', 'helpButton', 'helpCardButtonMessage',
    'helpCardParagraph', 'pasvaz.bindonce', 'ngProgress', 'applicationDeadline', 'angularRedactor','helpCardAwardCalculation',
    'ngHtmlCompile', 'policyModel', 'ng.deviceDetector', 'messageModel', 'sliderService', 'ui.mask', 'ui.grid', 'ui.sortable', 'ui.validate', 
    'applicationSubcategories', 'ismAngularLib', 'textAngular', 'ismDateTime', 'angularFileUpload', 'credit-cards', 'jlareau.bowser'])

ismfast.config(['$stateProvider', '$httpProvider', function($stateProvider, $httpProvider) {
    $.each(stateProviders, function(key, value) {
        $stateProvider.state(value);

    });
    //initialize get if not there
    if (!$httpProvider.defaults.headers.get) {
        $httpProvider.defaults.headers.get = {};
    }
    //disable IE ajax request caching
    $httpProvider.defaults.headers.get['If-Modified-Since'] = '0';
    $httpProvider.defaults.headers.common = {};
    $httpProvider.defaults.headers.post = {};
    $httpProvider.defaults.headers.put = {};
    $httpProvider.defaults.headers.patch = {};

}]); 

ismfast.factory('$exceptionHandler', function ($log) {
    var airbrake = new airbrakeJs.Client({
        projectId: errbitKey,
        projectKey: errbitKey,
        reporter: 'xhr',
        host: 'https://errbit.ismfast.com'
    });

    airbrake.addFilter(function (notice) {
        notice.context.environment = 'javascript';
        notice.context.version = versionNo;
        return notice;
    });

    return function (exception, cause) {
        $log.error(exception);
        airbrake.notify({error: exception, params: {angular_cause: cause}});
    };
});

ismfast.run([
    "$rootScope", "$state", function($rootScope, $state) {
        $rootScope.$on("$stateChangeStart", (ev, to, toParams, from, fromParams) => {
            let helper = function() {
                ev.preventDefault();
                swal({
                    title: "Are you sure?",
                    text: "You have made changes without saving, are you sure you want to exit the page?",
                    type: "warning",
                    showCancelButton: true,
                    confirmButtonColor: "#DD68BB",
                    confirmButtonText: "Yes",
                    closeOnConfirm: true
                },
                () => {
                    if ($rootScope.model.constructor === Array) {
                        for (let j = 0; j < $rootScope.model.length; j++) {
                            $rootScope.model[j].revertCopy();
                        }
                        $state.go(to.name);
                    } else {
                        $rootScope.model.revertCopy();
                        $state.go(to.name);
                    }
                });
            };
            if ($rootScope.model !== undefined) {
                if ($rootScope.model.constructor === Array) {
                    for (let i = 0; i < $rootScope.model.length; i++) {
                        if ($rootScope.model[i].isDirty()) {
                            helper();
                            return;
                        }
                    }
                } else if ($rootScope.model.isDirty()) {
                    if ($rootScope.model.data[0].yearDiff === undefined) {
                        helper();
                    }
                }
            }
        });
    }
]);
